import React from "react";
import { Card } from "@/components/ui/card";

export default function EmptyState({ icon: Icon, title, description, action }) {
  return (
    <Card className="p-10 text-center bg-card">
      {Icon ? <div className="mx-auto mb-3 w-12 h-12 rounded-full bg-secondary grid place-items-center"><Icon className="w-5 h-5" style={{color:"hsl(347 72% 22%)"}} /></div> : null}
      <div className="font-display text-2xl text-foreground mb-1">{title}</div>
      {description && <div className="text-sm text-muted-foreground mb-4 max-w-md mx-auto">{description}</div>}
      {action}
    </Card>
  );
}

export function PageHeader({ title, subtitle, actions }) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-4 mb-6">
      <div>
        <h1 className="font-display text-3xl md:text-4xl text-foreground leading-tight">{title}</h1>
        {subtitle && <p className="text-sm text-muted-foreground mt-1">{subtitle}</p>}
      </div>
      {actions && <div className="flex gap-2">{actions}</div>}
    </div>
  );
}

export function Disclaimer({ children }) {
  return (
    <div className="text-[11px] uppercase tracking-wide text-muted-foreground py-2">
      {children || "Compliance support only • Not legal advice • Final clearance may require qualified counsel"}
    </div>
  );
}
